import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { SectionHeadline } from '@/components/SectionHeadline';
import React from 'react';
import { DataBox, InfoBoxes } from '@/components/boxes';
import IconPay from '@/assets/icons/heroIcons/Pay.svg';
import IconCart from '@/assets/icons/heroIcons/Shopping-cart.svg';
import IconSpeaker from '@/assets/icons/heroIcons/Speakerphone.svg';
import IconCog from '@/assets/icons/heroIcons/Cog.svg';
import { Button } from '@/components/buttons';
export function Facts(t0) {
  const $ = _c(82);
  const {
    onCtaClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["cssProgram"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] !== t) {
    t2 = t("dataBoxes.title");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <div className="mx-auto max-w-192"><SectionHeadline className="mb-12 lg:mb-16" variant="inverted" anchorKey="dataBoxes.title">{t2}</SectionHeadline></div>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("dataBoxes.1.text");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t) {
    t5 = t("dataBoxes.1.title");
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <DataBox text={t4} title={t5} variant="light" />;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t) {
    t7 = t("dataBoxes.2.text");
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t("dataBoxes.2.title");
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t7 || $[17] !== t8) {
    t9 = <DataBox text={t7} title={t8} variant="light" />;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t) {
    t10 = t("dataBoxes.3.text");
    $[19] = t;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t) {
    t11 = t("dataBoxes.3.title");
    $[21] = t;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t10 || $[24] !== t11) {
    t12 = <DataBox text={t10} title={t11} variant="light" />;
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12 || $[27] !== t6 || $[28] !== t9) {
    t13 = <div className="flex flex-col items-center justify-center gap-2 px-5 pb-14 lg:flex-row lg:gap-8 lg:pb-20">{t6}{t9}{t12}</div>;
    $[26] = t12;
    $[27] = t6;
    $[28] = t9;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t) {
    t14 = t("infoBoxes.title");
    $[30] = t;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t14) {
    t15 = <SectionHeadline className="mt-14 mb-12 lg:mt-20 lg:mb-16" variant="inverted" anchorKey="infoBoxes.title">{t14}</SectionHeadline>;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t) {
    t16 = t("infoBoxes.1.title");
    $[34] = t;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t) {
    t17 = t("infoBoxes.1.text");
    $[36] = t;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <IconPay />;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== t16 || $[40] !== t17) {
    t19 = {
      title: t16,
      paragraph: t17,
      icon: t18
    };
    $[39] = t16;
    $[40] = t17;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== t) {
    t20 = t("infoBoxes.2.title");
    $[42] = t;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  let t21;
  if ($[44] !== t) {
    t21 = t("infoBoxes.2.text");
    $[44] = t;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <IconCart />;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  let t23;
  if ($[47] !== t20 || $[48] !== t21) {
    t23 = {
      title: t20,
      paragraph: t21,
      icon: t22
    };
    $[47] = t20;
    $[48] = t21;
    $[49] = t23;
  } else {
    t23 = $[49];
  }
  let t24;
  if ($[50] !== t) {
    t24 = t("infoBoxes.3.title");
    $[50] = t;
    $[51] = t24;
  } else {
    t24 = $[51];
  }
  let t25;
  if ($[52] !== t) {
    t25 = t("infoBoxes.3.text");
    $[52] = t;
    $[53] = t25;
  } else {
    t25 = $[53];
  }
  let t26;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <IconSpeaker />;
    $[54] = t26;
  } else {
    t26 = $[54];
  }
  let t27;
  if ($[55] !== t24 || $[56] !== t25) {
    t27 = {
      title: t24,
      paragraph: t25,
      icon: t26
    };
    $[55] = t24;
    $[56] = t25;
    $[57] = t27;
  } else {
    t27 = $[57];
  }
  let t28;
  if ($[58] !== t) {
    t28 = t("infoBoxes.4.title");
    $[58] = t;
    $[59] = t28;
  } else {
    t28 = $[59];
  }
  let t29;
  if ($[60] !== t) {
    t29 = t("infoBoxes.4.text");
    $[60] = t;
    $[61] = t29;
  } else {
    t29 = $[61];
  }
  let t30;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <IconCog />;
    $[62] = t30;
  } else {
    t30 = $[62];
  }
  let t31;
  if ($[63] !== t28 || $[64] !== t29) {
    t31 = {
      title: t28,
      paragraph: t29,
      icon: t30
    };
    $[63] = t28;
    $[64] = t29;
    $[65] = t31;
  } else {
    t31 = $[65];
  }
  let t32;
  if ($[66] !== t19 || $[67] !== t23 || $[68] !== t27 || $[69] !== t31) {
    t32 = <div className="mx-auto max-w-[72rem]"><InfoBoxes withCharacters={true} items={[t19, t23, t27, t31]} variant="inverted" className="px-4 pb-12 lg:pb-16" /></div>;
    $[66] = t19;
    $[67] = t23;
    $[68] = t27;
    $[69] = t31;
    $[70] = t32;
  } else {
    t32 = $[70];
  }
  let t33;
  if ($[71] !== t) {
    t33 = t("infoBoxes.button");
    $[71] = t;
    $[72] = t33;
  } else {
    t33 = $[72];
  }
  let t34;
  if ($[73] !== onCtaClick || $[74] !== t33) {
    t34 = <Button onClick={onCtaClick} analyticsParam="tryGCSS" testId="tryGCSS" variant="primary" align="center" size="lg">{t33}</Button>;
    $[73] = onCtaClick;
    $[74] = t33;
    $[75] = t34;
  } else {
    t34 = $[75];
  }
  let t35;
  if ($[76] !== t13 || $[77] !== t15 || $[78] !== t3 || $[79] !== t32 || $[80] !== t34) {
    t35 = <>{t3}{t13}{t15}{t32}{t34}</>;
    $[76] = t13;
    $[77] = t15;
    $[78] = t3;
    $[79] = t32;
    $[80] = t34;
    $[81] = t35;
  } else {
    t35 = $[81];
  }
  return t35;
}